import { companySepaMandatePath } from "@oysterhr/router"
import { CustomerBankAccountMandateStateEnumType, Maybe, B2BPaymentMethod } from "@oysterhr/schema"
import { Callout } from "@oysterhr/ui"
import { useTranslation } from "react-i18next"
import { PaymentMethodEnumType } from "~/app/utils/constants"

interface ConfirmMandateSharingAlertProps {
  paymentMethod?: Maybe<B2BPaymentMethod>
  companyId: string
  onConfirm: () => void
}

export const ConfirmMandateSharingAlert = ({
  paymentMethod,
  companyId,
  onConfirm,
}: ConfirmMandateSharingAlertProps) => {
  const { t } = useTranslation("company_interface/CompanyPaymentMethodsPage/SepaFlow", {
    keyPrefix: "alerts.mandateSharing",
  })

  if (
    paymentMethod?.__typename !== PaymentMethodEnumType.CUSTOMER_BANK_ACCOUNT_SEPA ||
    paymentMethod.mandate?.state !== CustomerBankAccountMandateStateEnumType.Signed
  )
    return null

  return (
    <Callout variation="warning">
      <Callout.Heading>{t("title")}</Callout.Heading>
      <Callout.Content>{t("content")}</Callout.Content>
      <Callout.Actions>
        <Callout.ActionButton variation="outline" onClick={onConfirm}>
          {t("action")}
        </Callout.ActionButton>
        <Callout.ActionLink to={companySepaMandatePath(companyId)}>{t("link")}</Callout.ActionLink>
      </Callout.Actions>
    </Callout>
  )
}
